export default __webpack_public_path__ + "static/media/justin.b1004637.jpg";